<template>
  <div class="datatable">
    <div class="top">
      <Row :gutter="32">
        <Col span="6">
          <div class="box bg1">
            <div class="box-left blue">
              <img src="../assets/shuju.png" alt="" />
            </div>
            <div class="box-right">
              <p class="small">案例总量</p>
              <p class="big">{{ fourdata?toThousands(fourdata[0].Total):'' }}</p>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="box bg2">
            <div class="box-left green">
              <img src="../assets/dianzan.png" alt="" />
            </div>
            <div class="box-right">
              <p class="small">参与医生</p>
              <p class="big">{{ fourdata?toThousands(fourdata[1].Total):'' }}</p>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="box bg3">
            <div class="box-left yellow">
              <img src="../assets/daojishi.png" alt="" />
            </div>
            <div class="box-right">
              <p class="small">本月新增案例数量</p>
              <p class="big">{{ fourdata?toThousands(fourdata[0].ThisMonth):'' }}</p>
              <p class="small">
                <Icon :type='casePercent>0?"md-arrow-round-up":"md-arrow-round-down"' :color='casePercent>0?"green":"red"' />{{
                  casePercent='Infinity'?0:Math.abs(casePercent)
                }}% 同比上月
              </p>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="box bg4">
            <div class="box-left pink">
              <img src="../assets/xinzeng.png" alt="" />
            </div>
            <div class="box-right">
              <p class="small">本月新增医生数量</p>
              <p class="big">{{ fourdata?toThousands(fourdata[1].ThisMonth):'' }}</p>
              <p class="small">
                <Icon :type='docPercent>0?"md-arrow-round-up":"md-arrow-round-down"' :color='docPercent>0?"green":"red"' />{{
                  docPercent=='Infinity'?0:Math.abs(docPercent)
                }}% 同比上月
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="table">
      <div class="table-top">
        <Tabs :animated="false">
          <TabPane label="案例数量" name="name1">
            <div class="anliqushi">
              <div class="name">
                案例趋势
              </div>
              <div id="myChart"></div>
            </div>
            <div class="doctorlist">
              <List header="案例数量排名" border size="large">
                <ListItem v-for="(item, index) in demoLists" :key="index">
                  <div class="listitem">
                    <div style="display:flex;">
                      <span
                      style="margin-right:25px;"
                        class="circle"
                        :class="item.id > 3 ? 'white' : 'black'"
                        >{{ index + 1 }}</span
                      >
                      <span class="hosName">{{ item.Team }}</span>
                    </div>
                    <span class="demoNum">{{ item.num }}</span>
                  </div>
                </ListItem>
              </List>
            </div>
          </TabPane>
          <TabPane label="医生数量" name="name2">
            <div class="anliqushi">
              <div class="name">
                医生趋势
              </div>
              <div id="myChart_doc"></div>
            </div>
            <div class="doctorlist">
              <List header="案例数量排名" border size="large">
                <ListItem v-for="(item, index) in demoLists" :key="index">
                  <div class="listitem">
                    <div style="display:flex;">
                      <span
                        style="margin-right:25px;"
                        class="circle"
                        :class="item.id > 3 ? 'white' : 'black'"
                        >{{ index + 1 }}</span
                      >
                      <span class="hosName">{{ item.Team }}</span>
                    </div>
                    <span class="demoNum">{{ item.num }}</span>
                  </div>
                </ListItem>
              </List>
            </div>
          </TabPane>
          <div class="time" slot="extra">
            <div class="content">
              <span
                class="timedata"
                :class="spannumber == 0 ? 'active' : ''"
                @click="addactive($event)"
                >今日</span
              >
              <span
                class="timedata"
                :class="spannumber == 1 ? 'active' : ''"
                @click="addactive($event)"
                >本周</span
              >
              <span
                class="timedata"
                :class="spannumber == 2 ? 'active' : ''"
                @click="addactive($event)"
                >本月</span
              >
              <span
                class="timedata"
                :class="spannumber == 3 ? 'active' : ''"
                @click="addactive($event)"
                >全年</span
              >
              <DatePicker
                type="daterange"
                split-panels
                placeholder="输入日期"
                style="width: 300px"
                @on-change="getMydata"
                @on-clear="showData"
              ></DatePicker>
            </div>
          </div>
        </Tabs>
      </div>
      <div class="table-bottom">
        <div class="completionRate">
          <div class="completeBox column">
            <div class="completeArr" :style="{ left: n * -313 + 'px' }">
              <div
                class="completeItem"
                v-for="(item, index) in completeArr"
                :class="completeNum == index ? 'active' : ''"
                :key="index"
                @click="changeComplete(index,item.CenterID)"
              >
                <div class="centerName">{{item.Team}}</div>
                <div class="bottomContent">
                  <div class="contentLeft">
                    <p class="completeTitle">完成率</p>
                    <p class="completeNum">{{ item.percent }}%</p>
                  </div>
                  <MyCricle
                    :percent="item.percent"
                    :stroke-width="20"
                    :trail-width="20"
                    :size="60"
                    stroke-linecap="square"
                  >
                  </MyCricle>
                </div>
              </div>
            </div>
          </div>
          <Icon
            class="jiantouL column"
            type="ios-arrow-back"
            size="30"
            @click="leftClick"
          />
          <Icon
            class="jiantouR column"
            type="ios-arrow-forward"
            size="30"
            @click="rightClick"
          />
        </div>
        <div class="regionalData">
          <div class="regionalLeft">
            <span class="regionalTitle">案例类型</span>
            <div id="demo"></div>
          </div>
          <div class="regionalRight">
            <span class="regionalTitle">业务排行榜</span>
            <RadioGroup v-model="activityBtn" type="button">
              <Radio label="中心专家活跃度">中心专家活跃度</Radio>
              <Radio label="基层医生活跃度">基层医生活跃度</Radio>
            </RadioGroup>
            <Table
              :columns="
                activityBtn == '中心专家活跃度' ? expertHead : doctorHead
              "
              :data="activityBtn == '中心专家活跃度' ? expertData : doctorData"
            >
              <template slot-scope="{ row, index }" slot="jindutiao">
                <Progress :percent="row.percent" status="active">
                  <span>{{ row.percent + '%' }}</span>
                </Progress>
              </template>
            </Table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  DatePicker,
  Button,
  Table,
  Progress,
  Tabs,
  TabPane,
  List,
  Circle,
  RadioGroup,
  Radio,
} from "view-design";
import Request from "../utils/request";
import config from "../config";
import dayjs from "dayjs";
import Vue from "vue";
// import func from '../../vue-temp/vue-editor-bridge'
let echarts = require("echarts/lib/echarts");
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Row,
    Col,
    Icon,
    DatePicker,
    Button,
    Table,
    Progress,
    Tabs,
    TabPane,
    List,
    ListItem: List.Item,
    MyCricle: Circle,
    RadioGroup,
    Radio,
  },
  data() {
    // 这里存放数据
    return {
      spannumber: 2, //选择日期的类型
      dataStartToEnd: [dayjs()
        .startOf("month")
        .format("YYYY-MM-DD "),dayjs().format("YYYY-MM-DD ")], //开始和结束两天
      demoLists: [
        //案例数量排名
        { id: 1, Team: "齐鲁神外中心", num: 970 },
        { id: 2, Team: "毓璜顶神外中心", num: 770 },
        { id: 3, Team: "青医神外中心", num: 670 },
        { id: 4, Team: "齐鲁神外中心", num: 570 },
        { id: 5, Team: "齐鲁神外中心", num: 470 },
        { id: 6, Team: "齐鲁神外中心", num: 370 },
        { id: 4, Team: "齐鲁神外中心", num: 570 },
        { id: 5, Team: "齐鲁神外中心", num: 470 },
        { id: 6, Team: "齐鲁神外中心", num: 370 },
      ],
      completeArr: [1, 2, 3, 4, 5], //完成率数组
      //专家表头
      expertHead: [
        {
          title: "排名",
          key: "rank",
          width:'70px',
          align:'center'
        },
        {
          title: "专家名称",
          key: "name",
        },
        {
          title: "指数",
          key: "mark",
          slot: "jindutiao",
          width:'170px'
        },
        {
          title: "数量",
          key: "num",
        },
      ],
      //专家数据
      expertData: [
        {
          rank: 1,
          name: "John Brown",
          percent: 50,
          num: 66,
          date: "2016-10-03",
        },
        {
          rank: 2,
          name: "Jim Green",
          percent: 24,
          num: 55,
          date: "2016-10-01",
        },
        {
          rank: 3,
          name: "Joe Black",
          percent: 16,
          num: 44,
          date: "2016-10-02",
        },
        {
          rank: 4,
          name: "Jon Snow",
          percent: 10,
          num: 33,
          date: "2016-10-04",
        },
      ],
      //活跃度按钮
      activityBtn: "中心专家活跃度",
      //医生表头
      doctorHead: [
        {
          title: "排名",
          key: "rank",
          width:'70px',
          align:'center'
        },
        {
          title: "医生名称",
          key: "name",
        },
        {
          title: "指数",
          key: "mark",
          slot: "jindutiao",
          width:'170px'
        },
        {
          title: "数量",
          key: "num",
        },
      ],
      //医生数据
      doctorData: [
        {
          rank: 1,
          name: "林忠玮",
          percent: 18,
          num: 99,
          date: "2016-10-03",
        },
        {
          rank: 2,
          name: "徐立起",
          percent: 24,
          num: 88,
          date: "2016-10-01",
        },
        {
          rank: 3,
          name: "倪少杰",
          percent: 30,
          num: 77,
          date: "2016-10-02",
        },
        {
          rank: 4,
          name: "J崔忠梓",
          percent: 26,
          num: 66,
          date: "2016-10-04",
        },
      ],
      //完成率的号码
      completeNum: 0,
      n: 0,//右边多出的个数
      fourdata:'',//上面的四个数据
      casePercent:0,//案例百分比
      docPercent:0,//医生百分比
      caseDateArr:[],//案例趋势的时间
      caseNumArr:[],//案例趋势的数量
      docDateArr:[],//医生的时间
      docNumArr:[],//医生的数量
      completeArr:[
        {CenterID:1,Team:'齐鲁神外中心',percent:10},
        {CenterID:2,Team:'齐鲁神外中心',percent:20},
        {CenterID:3,Team:'齐鲁神外中心',percent:30},
        {CenterID:4,Team:'齐鲁神外中心',percent:40},
      ],//完成率数组
      m:0,
      table_bottom:[
        { value: 1048, name: "现场指导",percent:20 },
        { value: 735, name: "远程指导",percent:10 },
        { value: 580, name: "转院",percent:5 },
      ]
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$emit("funChangeTitle", "首页", "1");
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.drawLine();
    this.GetModuleData();
    this.CompletionRate();
    this.GetCenterRank()
    this.GetCaseNum().then(()=>{
        this.drawLine();
    });
  },
  // 这里存放数据
  beforeCreate() {},
  // 生命周期 - 挂载之前
  beforeMount() {},
  // 生命周期 - 更新之前
  beforeUpdate() {},
  // 生命周期 - 更新之后
  updated() {},
  // 生命周期 - 销毁之前
  beforeDestroy() {},
  // 生命周期 - 销毁完成
  destroyed() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
  // 方法集合
  methods: {
    //获取所有中心的完成率
    CompletionRate(){
      Request.getRequest(config.SXG_baseUrl+'/api/home/CompletionRate',{

      }).then(res=>{
        this.completeArr = res.data
        this.changeComplete(0,res.data[0].CenterID)
        if(res.data.length>5){
          this.m = res.data.length-5
        }else{this.m = 0}
      })
    },
    //获取排名
    GetCenterRank(){
      Request.getRequest(config.SXG_baseUrl+'/api/home/GetCenterRank',{
        startdate:this.dataStartToEnd[0],
        enddate:this.spannumber == 0?this.dataStartToEnd[0]:this.dataStartToEnd[1]
      }).then(res=>{
        this.demoLists = res.data
      })
    },
    //获取案例数量
    async GetCaseNum(){
      this.caseNumArr = [];
      this.caseDateArr = [];
      this.docNumArr = [];
      this.docDateArr = [];
      await Request.postRequest(config.SXG_baseUrl+'/api/home/GetCaseOrDocNum',{
        tablename:'caselist',
        startdate:this.dataStartToEnd[0],
        enddate:this.spannumber == 0?this.dataStartToEnd[0]:this.dataStartToEnd[1]
      }).then(res=>{
        res.data.map(item=>{
          this.caseDateArr.push(dayjs(item.date).format('MM-DD')),
          this.caseNumArr.push(item.num)
        })
      })
      await Request.postRequest(config.SXG_baseUrl+'/api/home/GetCaseOrDocNum',{
        tablename:'DocList',
        startdate:this.dataStartToEnd[0],
        enddate:this.spannumber == 0?this.dataStartToEnd[0]:this.dataStartToEnd[1]
      }).then(res=>{
        res.data.map(item=>{
          this.docDateArr.push(dayjs(item.date).format('MM-DD')),
          this.docNumArr.push(item.num)
        })
      })
    },
    //转换数字带逗号
    toThousands(num) {
      var result = "",
        counter = 0;
      num = (num || 0).toString();
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) {
          result = "," + result;
        }
      }
      return result;
    },
    //获取顶部4个模块的数据
    GetModuleData(){
      Request.getRequest(config.SXG_baseUrl+'/api/home/GetModuleData',{
      }).then(res=>{
        if(res.code == 200){
          this.fourdata = res.data
          this.casePercent = (this.fourdata[0].ThisMonth*1 - this.fourdata[0].LastMonth*1)/(this.fourdata[0].LastMonth*1).toFixed(2)*100
          this.docPercent = (this.fourdata[1].ThisMonth*1 - this.fourdata[1].LastMonth*1)/(this.fourdata[1].LastMonth*1).toFixed(2)*100
        }
      })
    },
    //点击右滑
    rightClick() {
      if(this.m>0&&this.m>this.n){
        this.n = this.n+1;
      }
    },
    leftClick() {
      if(this.n>0){
        this.n = this.n-1
      }
    },

    //改变完成率的号码
    changeComplete(index,id) {
      this.completeNum = index;
      Request.getRequest(config.SXG_baseUrl+'/api/home/GetCaseType',{
        CenterID:id
      }).then(res=>{
        if(res.code == 200){
          let arr = [
            { name: "现场指导"},
            {  name: "远程指导" },
            {  name: "转院治疗"},
          ]
          /* 
          table_bottom:[
            { value: 1048, name: "现场指导",percent:20 },
            { value: 735, name: "远程指导",percent:10 },
            { value: 580, name: "转院",percent:5 },
          ]
          */
          arr.map(item=>{
            if(item.name == '现场指导'){
              item.value = res.data[0].OnSite
              item.percent = Math.floor(res.data[0].OnSiteP)
            }else if(item.name == '远程指导'){
              item.value = res.data[0].Remote
              item.percent = Math.floor(res.data[0].RemoteP)
            }else if(item.name == "转院治疗"){
              item.value = res.data[0].Transfer
              item.percent = Math.floor(res.data[0].TransferP)
            }
          })
          this.table_bottom = arr
          this.drawLine();
        }
      })
      this.GetActivityCenter(id)
      this.GetActivityJc(id)
    },
    //获取中心业务排行榜
    GetActivityCenter(id){
      Request.getRequest(config.SXG_baseUrl+'/api/home/GetActivity',{
        CenterID:id,
        DocType:'中心'
      }).then(res=>{
        console.log(res)
        /*[
           {
          rank: 4,
          name: "Jon Snow",
          age: 26,
          sum: 33,
          date: "2016-10-04",
        },
      ], */
        if(res.code == 200){
          let arr = []
          let sum = 0;
          let arr1 = []
          arr1 = res.data.sort((a,b)=>{return b.Num-a.Num})
          res.data.map(item=>{
            sum +=item.Num
          })
          arr1.map((item1,index)=>{
            arr.push({rank:index+1,name:item1.DocName,percent:Math.floor((item1.Num/sum).toFixed(2)*100),num:item1.Num})
          })
          console.log(arr)
          this.expertData = arr
        }
      })
    },

    //获取中心业务排行榜
    GetActivityJc(id){
      Request.getRequest(config.SXG_baseUrl+'/api/home/GetActivity',{
        CenterID:id,
        DocType:'基层'
      }).then(res=>{
        console.log(res)
        if(res.code == 200){
          let arr = []
          let sum = 0;
          let arr1 = []
          arr1 = res.data.sort((a,b)=>{return b.Num-a.Num})
          res.data.map(item=>{
            sum +=item.Num
          })
          arr1.map((item1,index)=>{
            arr.push({rank:index+1,name:item1.DocName,percent:Math.floor((item1.Num/sum)*100),num:item1.Num})
          })
          console.log(arr)
          this.doctorData = arr
        }
      })
    },

    //选择不同的日期类型
    addactive(e) {
      if (e.target.innerHTML == "今日") {
        console.log(123);
        this.spannumber = 0;
        let data = [];
        data.push(dayjs().format("YYYY-MM-DD "));
        this.dataStartToEnd = data;
        this.GetCenterRank()
        this.GetCaseNum().then(()=>{
            this.drawLine();
        });
        // this.getMydata(data)
      } else if (e.target.innerHTML == "本周") {
        this.spannumber = 1;
        let data = [];
        data.push(
          dayjs()
            .startOf("week")
            .format("YYYY-MM-DD ")
        );
        data.push(dayjs().format("YYYY-MM-DD "));
        this.dataStartToEnd = data;
        this.GetCenterRank()
        this.GetCaseNum().then(()=>{
            this.drawLine();
        });
        // this.getMydata(data)
      } else if (e.target.innerHTML == "本月") {
        this.spannumber = 2;
        let data = [];
        data.push(
          dayjs()
            .startOf("month")
            .format("YYYY-MM-DD ")
        );
        data.push(dayjs().format("YYYY-MM-DD "));
        this.dataStartToEnd = data;
        this.GetCenterRank()
        this.GetCaseNum().then(()=>{
            this.drawLine();
        });
        // this.getMydata(data)
      } else {
        this.spannumber = 3;
        let data = [];
        data.push(
          dayjs()
            .startOf("year")
            .format("YYYY-MM-DD ")
        );
        data.push(dayjs().format("YYYY-MM-DD "));
        this.dataStartToEnd = data;
        this.GetCenterRank()
        this.GetCaseNum().then(()=>{
            this.drawLine();
        });
      }
      console.log("起始和结束两天", this.dataStartToEnd);
    },
    //获取包含天的数组
    getMydata(data) {
      if (document.querySelector(".ivu-input").value) {
        this.spannumber = 4;
      }
      console.log("on-change后", data);
      this.dataStartToEnd = data;
      this.GetCenterRank()
      this.GetCaseNum().then(()=>{
            this.drawLine();
        });
    },
    //删除日期选择器中的内容
    showData() {
      console.log("删除日期选择器中的内容");
    },
    //制作echart表
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let myChart_doc = this.$echarts.init(document.getElementById("myChart_doc"));
      
      let myDemo = this.$echarts.init(document.getElementById("demo"));
      let myChartTable = {
        title: {
          // text: '申请趋势'
        },
        color: ["#60D4D7"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["数量"],
          icon: "circle",
          color: "#7DA9FE",
          right: "200",
          // type:'plain'
        },

        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.caseDateArr.length>0?this.caseDateArr:["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            // symbol: "none",
            name: "数量",
            type: "line",
            stack: "总量",
            data: this.caseNumArr.length>0?this.caseNumArr:[220, 182, 191, 234, 290, 330, 310],
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#60D4D7",
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#C9EBF5", //改变区域颜色
              },
            },
          },
        ],
      };
      let myChartTable_doc = {
        title: {
          // text: '申请趋势'
        },
        color: ["#60D4D7"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["数量"],
          icon: "circle",
          color: "#7DA9FE",
          right: "200",
          // type:'plain'
        },

        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.docDateArr.length>0?this.docDateArr:["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            symbol: "none",
            name: "数量",
            type: "line",
            stack: "总量",
            data: this.docNumArr.length>0?this.docNumArr:[220, 182, 191, 234, 290, 330, 310],
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#60D4D7",
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#C9EBF5", //改变区域颜色
              },
            },
          },
        ],
      };

      let data = this.table_bottom;
      let myDemoTable = {
        title: {
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 20,
          top: 80,
          icon: "circle",
          data: ["现场指导", "远程指导", "转院治疗"],
          textStyle: {
            //图例文字的样式
            fontSize: 24,
          },
          formatter: function(name) {
            let target;
            let percent;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                target = data[i].value;
                percent = data[i].percent
              }
            }
            let str = "%"
            if(percent.toString().length == 1){
              str = "%        "
            }else if(percent.toString().length == 2){
              str = "%      "
            }else if(percent.toString().length == 3){
              str = "%    "
            }
            let arr = [name + "    |    " + percent + str + target];
            return arr.join("\n");
          },
        },
        color: ["#49A9EE", "#98D87D", "#FFD86E"],
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "70%",
            center: ["35%", "40%"], //这个属性调整图像的位置
            data: this.table_bottom,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            labelLine: {
              show: false,
              // color:"#EFEFEF"
            },
            label: {
              show: false,
            },
          },
        ],
      };
      // 绘制图表
      myChart.setOption(myChartTable);
      myChart_doc.setOption(myChartTable_doc);
      myDemo.setOption(myDemoTable);
    },
  },
  // 监听属性 类似于data概念
  computed: {
    
  },
  // 监控data中的数据变化
  watch: {},
};
</script>

<style lang="less">
.datatable {
  width: 100%;
  background: rgb(240, 242, 245);
  box-sizing: border-box;
  padding-right: 1%;
  .top {
    width: 100%;
    height: 100px;
    // background: blue;
    overflow: hidden;
    background: rgb(240, 242, 245);
    .ivu-row {
      height: 100%;
      .ivu-col {
        height: 100%;
        // background: yellow;
        .box {
          height: 100%;
          // background-color: red; /* 不支持线性的时候显示 */
          color: rgb(102, 102, 102);
          display: flex;
          justify-content: center;
          align-items: center;
          background: white;
          .box-left {
            width: 50px;
            height: 50px;
            margin-right: 30px;
            border-radius: 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            &.blue {
              background: #1296db;
            }
            &.green {
              background: #98d87d;
            }
            &.yellow {
              background: #ffd86e;
            }
            &.pink {
              background: #f3857c;
            }
          }
          .small {
            font-size: 12px;
          }
          .big {
            font-size: 30px;
          }
        }
      }
    }
  }
  .table {
    width: 100%;
    background: rgb(240, 242, 245);
    margin-top: 20px;
    box-sizing: border-box;
    .table-top {
      width: 100%;
      height: 500px;
      background: white;
      .ivu-tabs {
        height: 100%;
        box-sizing: border-box;
        position: relative;
        overflow: visible;
        color: #515a6e;
        zoom: 1;
        .ivu-tabs-content {
          height: 80%;
          .ivu-tabs-tabpane {
            display: flex;
            height: 100%;
            .anliqushi {
              width: 80%;
              height: 100%;
              background: white;
              .name {
                // font-weight: 600;
                font-size: 18px;
                margin-left: 30px;
                color: #000;
                // font-family: "Times New Roman", Times, serif;
              
              }
              #myChart {
                width: 100%;
                height: 100%;
                // margin-top: 10px;
              }
              #myChart_doc {
                width: 100%;
                height: 100%;
                // margin-top: 10px;
              }
            }
            .doctorlist {
              width: 20%;
              height: 100%;
              background: white;
              overflow: hidden;
              .ivu-list {
                border: none;
                height: 100%;
                .ivu-list-header {
                  // font-weight: 600;
                  font-size: 18px;
                  color: #000;
                  // font-family: "Times New Roman", Times, serif;
                  padding-top: 0;
                  border: none;
                }
                .ivu-list-container {
                  padding-top: 20px;
                  height: 100%;
                  box-sizing: border-box;
                  overflow: auto;
                  .ivu-list-items {
                    border: none;
                    .ivu-list-item {
                      border: none;
                      .listitem {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        .circle {
                          width: 20px;
                          height: 20px;
                          border-radius: 10px;
                          background: black;
                          color: white;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          &.black {
                            background: black;
                            color: white;
                          }
                          &.white {
                            background: rgb(224, 217, 217);
                            color: black;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .ivu-tabs-nav .ivu-tabs-tab {
        display: inline-block;
        height: 100%;
        padding: 16px 61px;
        margin-right: 16px;
        box-sizing: border-box;
        cursor: pointer;
        text-decoration: none;
        position: relative;
        transition: color 0.3s ease-in-out;
      }
      .ivu-tabs-nav-right {
        .time {
          // float: right;
          width: 100%;
          font-size: 12px;
          // overflow: hidden;
          box-sizing: border-box;
          padding-top: 10px;
          padding-right: 60px;
          .content {
            float: right;
            display: flex;
            .timedata {
              font-size: 14px;
              line-height: 32px;
              cursor: pointer;
              padding-right: 25px;
              &.active {
                color: rgb(16, 142, 233);
              }
            }
            .ivu-date-picker {
              margin: 0 5px;
            }
          }
        }
      }
    }
    .table-bottom {
      width: 100%;
      background: rgb(240, 242, 245);
      margin-top: 20px;
      box-sizing: border-box;
      .completionRate {
        width: 100%;
        height: 120px;
        padding-left: 2%; /* leftContent width */
        padding-right: 2%; /* rightContent width */
        overflow: hidden;
        .column {
          position: relative;
          float: left;
          height: 100%;
          line-height: 100%;
        }
        .completeBox {
          width: 100%;
          display: flex;
          overflow: hidden;
          position: relative;
          .completeArr {
            display: flex;
            height: 100%;
            position: absolute;
            transition: all .3s;
            .active {
              border: 2px solid rgb(31, 103, 196);
              border-radius: 10px;
            }
            .completeItem {
              width: 313px;
              height: 100%;
              background: white;
              box-sizing: border-box;
              padding-left: 40px;
              cursor: pointer;

              .centerName {
                height: 40%;
                display: flex;
                align-items: center;
                font-size: 16px;
              }
              .bottomContent {
                height: 60%;
                width: 100%;
                display: flex;
                .contentLeft {
                  width: 50%;
                  height: 100%;
                  .completeNum {
                    margin-top: 20px;
                    font-size: 26px;
                    color: black;
                    box-sizing: border-box;
                  }
                }
                .contentRight {
                  width: 50%;
                  height: 100%;
                }
              }
            }
          }
        }
        .ivu-icon {
          height: 100%;
          width: 2%;
          cursor: pointer;
          border: 1px solid rgb(216, 213, 213);
          display: flex;
          align-items: center;
          justify-content: center;
          &.jiantouL {
            width: 2%;
            right: 2%;
            margin-left: -100%;
            background: #2d8cf0;
            color:#fff;
          }
          &.jiantouR {
            width: 2%;
            right: -2%;
            margin-left: -2%;
            background: #2d8cf0;
            color:#fff;
          }
        }
      }
      .regionalData {
        overflow: hidden;
        width: 100%;
        height: 400px;
        // background: red;
        box-sizing: border-box;
        margin-top: 20px;
        background: white;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        .regionalLeft {
          width: 70%;
          height: 100%;
          border: 1px solid rgb(233, 233, 233);
          .regionalTitle {
            padding: 20px;
            height: 80px;
            line-height: 80px;
            font-size: 18px;
            // font-family: "Lucida Console", "Courier New", monospace;
            color: black;
            // font-weight: bold;
          }
          #demo {
            margin-left: 50px;
            width: 800px;
            height: 300px;
          }
        }
        .regionalRight {
          width: 29%;
          height: 100%;
          border: 1px solid rgb(233, 233, 233);
          box-sizing: border-box;
          overflow: hidden;
          .regionalTitle {
            display: block;
            padding: 10px 20px;
            width: 100%;
            font-size: 18px;
            // font-family: "Lucida Console", "Courier New", monospace;
            color: black;
            // font-weight: bold;
            border-bottom: 1px solid rgb(233, 233, 233);
          }
          .ivu-radio-group {
            margin-left: 20px;
            margin-top: 24px;
          }
          .ivu-table-wrapper {
            margin-top: 24px;

          }
          .ivu-table-body{
            height: 192px!important;
            overflow-y: auto;
            overflow-x: hidden;
          }
        }
      }
    }
  }
}
</style>
